import { GET_VIDEOS, SET_VIDEO_LOADING, REMOVE_VIDEO_LOADING } from "../types";

const initialState = {
    loading: false, // Initit loading state
    videoData: {},
    oldValue: ""
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_VIDEO_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_VIDEO_LOADING:
            return {
                ...state,
                loading: false
            };
        case GET_VIDEOS:
            return {
                ...state,
                videoData: { ...payload }
            };
        default:
            return state;
    }
}